import IStepThreeModel from './IStepThreeModel';

const StepThreeModelInitialState: IStepThreeModel = {
  moddatEtebarBN: undefined,
  taahodJaani: null,
  taahodRanandeh: null,
  wepodDiscountCode: null,
};

export default StepThreeModelInitialState;
